import introBackground from "../assets/images/Icon_Game.png";
// import introBackground from "../assets/images/Logo_Intro.png";
//import introDesc from "../assets/images/Tittle_Intro1.png";
//import introDescPortrait from "../assets/images/Tittle_Intro2.png";
import useScreenOrientation from './helpers/useScreenOrientation';

export default function Intro({ isVisible, setView }: any) {

  const isLandscape = useScreenOrientation();

  return (
    <div className={`full-intro-container ${isVisible === true ? 'active' : 'hidden'}`}>
      <div className={`intro-title ${isLandscape ? '' : 'portrait'}`}>
        <img className={`intro-title-img ${isLandscape ? '' : 'portrait'}`} src={introBackground} alt=''/>
      </div>
      {/* <div className={`intro-description ${isLandscape ? '' : 'portrait'}`}>
        <img className={`intro-description-img ${isLandscape ? '' : 'portrait'}`} src={isLandscape ? introDesc: introDescPortrait} alt=''/>
      </div> */}
      
      <div className={'intro-bottom'} onClick={() => setView("UserForm")} > {/* Instructions */}
        <div className='intro-bottom-text'>¡JUGAR!</div>
      </div>
    </div>
  );
}